import { TableCell, TableRow } from "@material-ui/core"
import React from "react"
import { DateHelper, reduceEspString } from "../../classes/Helper"

function calcESP(rssi, snr) {
  const a = 10 * Math.log10(1 + Math.pow(10, 0.1 * snr))
  let esp = rssi + snr - a

  return reduceEspString(esp)
}

function getTimestamp(rx, utc) {
  if (rx.fine_timestamp) {
    return rx.fine_timestamp.replace("Z", "").replace("T", " ") + " (FTS)"
  }

  if (rx.gps_timestamp) {
    return rx.gps_timestamp.replace("Z", "").replace("T", " ")
  }

  if (utc) {
    return new DateHelper().parseDate(utc).setMask("y-m-d h:i:s.ms").getUTCDate() + " (by server)"
  }

  return ""
}

export default function GateWaysTable(props) {
  if (!props.tableRxInfo || props.tableRxInfo.length === 0) return null

  return props.tableRxInfo.map((rx, c) => {
    return (
      <TableRow hover key={c}>
        <TableCell className={"cell pd"}>{rx.gateway_id}</TableCell>
        <TableCell className={"cell pd"}>{calcESP(rx.rssi, rx.lora_snr)}</TableCell>
        <TableCell className={"cell pd"}>{rx.rssi}</TableCell>
        <TableCell className={"cell pd"}>{rx.lora_snr}</TableCell>
        <TableCell className={"cell pd"}>{getTimestamp(rx, props.dateTime)}</TableCell>
      </TableRow>
    )
  })
}
